import type { AdsAssistantPostTagDefRow } from "@/lib/adsAssistantClient";

export function AdsAssistantPostTagPickFieldset(props: {
  postTagDefs: AdsAssistantPostTagDefRow[];
  selectedPostTags: Set<string>;
  togglePostTag: (id: string) => void;
}) {
  const { postTagDefs, selectedPostTags, togglePostTag } = props;
  if (!postTagDefs.length) return null;

  return (
    <fieldset>
      <legend className="text-[11px] font-medium text-gray-700 dark:text-gray-300">
        Post tags <span className="font-normal text-gray-500">(max 5)</span>
      </legend>
      <p className="mt-0.5 text-[10px] text-gray-500 dark:text-gray-500">
        Trainers define tags in the library; attach existing tags when logging. Filter indexed posts via API using{" "}
        <code className="rounded bg-gray-100 px-0.5 dark:bg-zinc-800">tag_slug</code> or{" "}
        <code className="rounded bg-gray-100 px-0.5 dark:bg-zinc-800">tag_id</code>.
      </p>
      <div className="mt-1 flex flex-wrap gap-2">
        {postTagDefs.map((t) => (
          <label
            key={t.id}
            className="inline-flex items-center gap-1 rounded border border-emerald-200/90 bg-white px-2 py-1 text-xs dark:border-emerald-900/60 dark:bg-zinc-950"
          >
            <input
              type="checkbox"
              checked={selectedPostTags.has(t.id)}
              disabled={!selectedPostTags.has(t.id) && selectedPostTags.size >= 5}
              onChange={() => togglePostTag(t.id)}
            />
            {t.label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
